import type {StateCreator} from 'zustand'
import type {PullRequestFileTreeDiff} from '../../page-data/payloads/file-tree'
import type {HiddenFilesSliceActions} from './hidden-files'

// I ALMOST want to call this the diff map, or something different
export type DiffSummariesSlice = {
  diffSummaries?: PullRequestFileTreeDiff[]
  setDiffSummaries: (diffSummaries?: PullRequestFileTreeDiff[]) => void
}

export const createDiffSummariesSlice =
  (): StateCreator<
    DiffSummariesSlice & HiddenFilesSliceActions,
    [['zustand/devtools', never]],
    [],
    DiffSummariesSlice
  > =>
  (set, get) => ({
    codeowners: undefined,
    setDiffSummaries: (diffSummaries?: PullRequestFileTreeDiff[]) => {
      set({diffSummaries}, undefined, 'updateDiffSummaries')
      get()._updateHiddenFiles()
    },
  })
